import { ETypes } from "app/pages/industry-analysis/players/table/bubble-chart/types";
import type { IRawData } from "../types";
import { EEntityType } from "app/components/React/Table/cells/SegmentOrDomainCell";

const typeToTrackingText = {
    [ETypes.BrandStrength]: "Brand Strength",
    [ETypes.CostEfficiency]: "Cost Efficiency",
    [ETypes.AudienceGrowth]: "Audience Growth",
    [ETypes.Loyalty]: "Loyalty",
    [ETypes.ConversionRate]: "Conversion Rate",
};
export const getTrackingFilters = (type: ETypes, showAverage: boolean) => {
    const trackingFilters = {
        QuadrantType: typeToTrackingText[type],
        IndustryAverageToggle: showAverage ? "on" : "off",
    };
    return trackingFilters;
};

export const getRawDataWithoutSegments = (rawData: IRawData) => {
    const clonedRawData = structuredClone(rawData);
    return {
      ...clonedRawData,
      Data: clonedRawData ? clonedRawData.Data.filter(({ Type: type }) => type !== EEntityType.SEGMENT) : [],
      CompareData:
        clonedRawData && clonedRawData.CompareData
          ? clonedRawData.CompareData.filter(({ Type: type }) => type !== EEntityType.SEGMENT)
          : [],
    };
  };
